module.exports = __webpack_public_path__ + "img/manage-2.5e56130e.png";